import { gql } from "@apollo/client";
import { client } from "..";

const insertEcUser = gql`
mutation MyMutation($objects: [ec_users_insert_input!] = {}) {
  insert_ec_users(objects: $objects) {
    affected_rows
  }
}
`

export const CreateEcUser = async (
    data, mtoken
) => {
    let resp;
    const value = {
        "name": data?.name,
        "phone_number": data?.mobile,        
    }
    try {
        resp = await client.mutate({
            mutation: insertEcUser,
            refetchQueries: [],
            variables: { "objects": [value] },
            context: {
                headers: {
                    "Content-Type": "application/json",
                    authorization:
                        `Bearer ${mtoken}`,
                },
            },
        });
        if (resp.errors) {
            console.log(resp.errors)
            // message.error(resp.errors);
            return resp.errors
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
    }
    // message.success(`Product ${data?.name} Created Successfully!'`, 5);
    return resp;
};